import { Link, useLocation } from "react-router-dom";
import PageShell from "@/components/feature/PageShell";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  const location = useLocation();

  usePageMeta({
    title: "页面不存在-色戒完整版无删减hd",
    description: "你访问的页面不存在，可返回首页继续浏览高清影视资料与影视资讯。",
    keywords: "页面不存在,404,影视资料,色戒完整版无删减hd",
  });

  return (
    <PageShell>
      <div className="mx-auto flex min-h-[60vh] max-w-shell flex-col items-center justify-center px-4 py-16 text-center md:px-6">
        <p className="font-label text-[72px] font-black leading-none text-background-300 md:text-[110px]">
          404
        </p>
        <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          这个页面还没有内容
        </h1>
        <p className="mt-2 font-label text-xs text-foreground-400">{location.pathname}</p>
        <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
          你访问的地址可能已经变更。可以回到首页，或者直接进入影视分类页浏览现有的影片资料。
        </p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-5-line" />
            回到首页
          </Link>
          <Link
            to="/category"
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600"
          >
            <i className="ri-grid-line" />
            影视分类
          </Link>
        </div>
      </div>
    </PageShell>
  );
}